import { render, staticRenderFns } from "./CoProprieteInfo.vue?vue&type=template&id=a50dcf22&"
import script from "./CoProprieteInfo.vue?vue&type=script&lang=js&"
export * from "./CoProprieteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports